import { Navigate } from 'react-router';

import {
  teamHasBillingError,
  useCurrentTeam,
  useUserQuery,
} from '@queries/user';
import { monitoring } from '@services/monitoring';

// Wraps children and redirects to the settings page if the user has a billing error.
export function BillingBounce({ children }: { children: React.ReactNode }) {
  const { team } = useCurrentTeam();

  const { data: currentUser } = useUserQuery({
    suspense: true,
  });

  if (
    teamHasBillingError(team) &&
    !currentUser?.email?.endsWith('@evervault.com')
  ) {
    monitoring.reportError(new Error('Billing error'), {
      teamUuid: team?.uuid,
    });
    return <Navigate to={`/${team?.uuid}/settings/team/billing`} replace />;
  }

  return children;
}
